import { useHistory, useParams } from "react-router-dom";
import { Button, Card, Divider, Header, Menu, Segment } from "semantic-ui-react";
import { useAppContext } from "../hooks/useAppContext";
import { PermitRegister } from "../models/PermitRegister";
import { Project } from "../models/Project";

const MyProjectsList = () => {
  const { myRegisters } = useAppContext();
  const { orgName } = useParams<{ orgName: string }>();
  const history = useHistory();

  // Group registers by project, preserving project order
  const projectsWithRegisters = myRegisters
    ? Array.from(
        myRegisters
          .filter((r) => r.project != null)
          .reduce((map, register) => {
            const project = register.project!;
            if (!map.has(project.id)) {
              map.set(project.id, { project, registers: [] });
            }
            map.get(project.id)!.registers.push(register);
            return map;
          }, new Map<string, { project: Project; registers: PermitRegister[] }>())
          .values(),
      )
    : undefined;

  const renderRegisterCard = (project: Project, register: PermitRegister) => (
    <Button
      basic
      style={{ marginBottom: "0.3em" }}
      compact
      key={register.id}
      onClick={() => history.push(`/${orgName}/projects/${project.name}/registers/${register.title}/dashboard`)}
    >
      {register.title}
    </Button>
  );

  const renderProjectCard = ({ project, registers }: { project: Project; registers: PermitRegister[] }) => (
    <Card key={project.id}>
      <Card.Content>
        <Card.Header>{project.name}</Card.Header>
        {project.location && <Card.Meta>{project.location}</Card.Meta>}
        <Divider />
        {registers.map((r) => renderRegisterCard(project, r))}
      </Card.Content>
    </Card>
  );

  return (
    <>
      <Segment basic>
        <Header as="h2">{orgName}</Header>
      </Segment>

      <Menu pointing secondary color="green">
        <Menu.Item name="Projects" active={true} />
      </Menu>

      <Segment basic loading={!myRegisters}>
        <Card.Group itemsPerRow={2}>{projectsWithRegisters?.map(renderProjectCard)}</Card.Group>
      </Segment>
    </>
  );
};

export default MyProjectsList;
